<template>
  <!--
      	作者：luoyiming
      	时间：2020-06-01
      	描述：插件中心-分销-分销订单
      -->
  <div class="user">
    <!-- 111111 -->
    <!-- <div class="nav" style="background-color: #fff !important">
      <div @click="ddxq(2)">
        <div :class="show == 2 ? 'dtclass' : ''">百融风控报告</div>
      </div>
      <div @click="ddxq(13)">
        <div :class="show == 13 ? 'dtclass' : ''">百融风控报告</div>
      </div>
    </div> -->
    <!-- 百融分控 -->
    <!-- 租先知 -->

    <!-- <template v-if="show == 2">
      <Fengkon ></Fengkon>
    </template>
    <template v-if="show == 13">
      <ZUXIANZHI></ZUXIANZHI>
    </template> -->
  </div>
</template>

<script>
import OrderApi from "@/api/order.js";
// import Fengkon from "@/dialog/detail.vue";
// import ZUXIANZHI from "@/dialog/zuXianZhi.vue";

export default {
  // components: {
  //   Fengkon,
  //   ZUXIANZHI
  // },
  data() {
    return {
      some: "",
      show: 2
    }
  },
  props: {},
  created() {
    /*获取列表*/
    // this.getData();
  },
  methods: {
    // 显示报告
    // ddxq(val) {
    //   this.show = val;
    // },
    /*获取数据*/
    // getData() {
    //   let self = this;
    //   let Params = {
    //     order_id: "",
    //     user_id: "",
    //     source_type: 2,
    //     username: "杜高达", //姓名
    //     usernum: "330281199110086436", //身份证
    //     mobile: "19106588239" //手机号
    //   };
    //   OrderApi.getControl(Params, true)
    //     .then(data => {
    //       console.log(data, "看看你看卡");
    //     })
    //     .catch(error => {
    //       self.loading = false;
    //     });
    // }
  }
};
</script>

<style scoped="">
.referee-name {
  width: 33.333333%;
}
/* .nav div .dtclass {
  background-color: #ffffff;
} */
</style>



// WEBPACK FOOTER //
// src/views/order/control/index copy.vue